/**
 * Quickly hashes a value for use with for example cache. It can hash 1000 short
 * strings in 5ms. This code is based of Java's String.hashCode. It should never
 * be used for passwords or other use cases that need security
 *
 * https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 * @param value String to hash
 */
export default function hashCode(value: string) {
  let hash = 0
  if (value.length === 0) {
    return hash
  }
  let i = 0
  for (i = 0; i < value.length; i += 1) {
    const char = value.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }

  return hash
}
